/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prepared_Actions_TitleInputs */

const en_prepared_actions_title = /** @type {(inputs: Prepared_Actions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions to confirm`)
};

/**
* | output |
* | --- |
* | "Actions to confirm" |
*
* @param {Prepared_Actions_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const prepared_actions_title = /** @type {((inputs?: Prepared_Actions_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prepared_Actions_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_prepared_actions_title(inputs)
});